export const Mixin = {
  methods: {
    createDate: function (date, hour) {
      const y = date.slice(0, 4)
      const m = date.slice(4, 6)
      const d = date.slice(6, 8)
      const h = hour || '00:00'
      const newDate = new Date(y + '/' + m + '/' + d + ' ' + h)
      return newDate
    },
    createMonday: function (targetDate) {
      const monday = targetDate.getDay() !== 0 ? targetDate.getDate() - targetDate.getDay() + 1 : targetDate.getDate() - targetDate.getDay() - 6
      const mondayDiff = targetDate.getDate() - monday
      targetDate.setDate(targetDate.getDate() - mondayDiff)
      const date = targetDate.getFullYear() + ('0' + (targetDate.getMonth() + 1)).slice(-2) + ('0' + targetDate.getDate()).slice(-2)
      return date
    },
    displayFullYear: function (d) {
      const date = this.createDate(d)
      return date.getFullYear()
    },
    displayMonth: function (d) {
      const date = this.createDate(d)
      return date.getMonth() + 1
    },
    displayDate: function (d) {
      const date = this.createDate(d)
      return date.getDate()
    },
    displayHours: function (d, h, a) {
      let date = this.createDate(d, h)
      if (a) {
        date.setMinutes(date.getMinutes() + a)
      }
      return ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2)
    },
    minToHour: function (t) {
      const hour = Math.floor(t / 60)
      const min = t % 60
      if (t >= 60) {
        if (min === 0) {
          return hour + '時間'
        } else {
          return hour + '時間' + min + '分'
        }
      } else {
        return t + '分'
      }
    },
    sumMinutes: function (menus) {
      const array = []
      for (let i = 0; i < menus.length; i++) {
        array.push(menus[i].minutes)
      }
      const sum = array.reduce(function (a, x) { return a + x })
      return sum
    },
    sumPrice: function (menus) {
      const array = []
      for (let i = 0; i < menus.length; i++) {
        array.push(menus[i].price)
      }
      const sum = array.reduce(function (a, x) { return a + x })
      return sum
    },
    openModal: function (target) {
      this.modal[target] = true
    },
    closeModal: function (target) {
      this.modal[target] = false
    }
  }
}
